import { format } from 'date-fns';

/**
 * The insights over-time series is dense: one point per month of the resolved
 * window, with null measures where no purchases exist. Null means two
 * different things depending on when the month is:
 *
 * - a **completed** month with null measures genuinely had no purchases — it
 *   plots as zero;
 * - a month that hasn't finished yet has no data *yet* — it stays unplotted,
 *   so lines stop at "now" while the axis still spans the window.
 */
export function isCompletedMonth(periodEndDate: string): boolean {
  return periodEndDate < format(new Date(), 'yyyy-MM-dd');
}
